import { useQuery } from "react-query";
import { getStaffPersonal } from "~/pages/StaffEmployeePersonal/GetStaffPersonal/getStaffPersonal";
import { useGetLocationData } from "~/hooks/locationData";

export default function useGetPersonal(date) {
  const { UserId, currentId, dateBegin } = useGetLocationData();

  const positionIds = currentId
    ? currentId.split(",").map((id) => id.trim())
    : [];

  return useQuery({
    queryKey: ["getDataStaffPersonal", UserId, currentId, date],
    queryFn: () =>
      getStaffPersonal({
        employeeId: UserId || "",
        positionIds,
        actualOn: date,
      }),
    refetchOnWindowFocus: false,
    cacheTime: 0,
    staleTime: 0,
    enabled: !!UserId,
  });
}
